var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31345 19.3267V11.116H10.2081L10.6415 7.91616H7.31337V5.87319C7.31337 4.94676 7.58355 4.31545 8.97899 4.31545L10.7587 4.31465V1.45273C10.4509 1.41381 9.39435 1.32666 8.16537 1.32666C5.59935 1.32666 3.84261 2.81784 3.84261 5.55638V7.91616H0.940491V11.116H3.84261V19.3266H7.31345V19.3267Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.49eb1c30e10b490c4fe0a3c5c50f9749.svg";
export { ForwardRef as ReactComponent };